import { Injectable } from "@angular/core";
import { DatePipe } from "@angular/common";
import { monthNames } from '../shared/constants';
import { fullMonthNames } from '../shared/constants';
import { country_list } from '../shared/constants';
import { monthOptions } from '../shared/constants';
@Injectable()
export class UtilService{
    constructor(private datePipe : DatePipe) { }
    public getDate(selectedDate)
    {
      var date = new Date(selectedDate);
        const month = this.datePipe.transform(date, 'MMMM');
        const dayofweek = this.datePipe.transform(date, 'DDDD');
        var data = {
          fullDate: date.getDate()+", "+month+" "+date.getFullYear(),
          date: {
            day : date.getDate(),
            month: date.getMonth()+1,
            year: date.getFullYear()
          },
          
        }
        return data;
    }

    preventPaste(e)
  {
    e.preventDefault();
    return false;
  }

  public getTodaysDate()
    {
      var date = new Date();
        const month = this.datePipe.transform(date, 'MMMM');
        const dayofweek = this.datePipe.transform(date, 'DDDD');
        var data = {
          fullDate: date.getDate()+", "+month+" "+date.getFullYear(),
          date: {
            day : date.getDate(),
            month: date.getMonth()+1,
            year: date.getFullYear()
          }
        }
        return data;
    }

    public getDayDifference(to,from)
    {
      const diffTime = Math.abs(to.getTime() - from.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
      //console.log("diffDays",diffDays);
      return diffDays;
    }

    public getFormatedDate(date)
    {
      return date.child('day').val()+" "+monthNames[date.child('month').val() -1]+", "+date.child('year').val();
    }
    public getDateFromObject(date)
    {
      //return date.child('day').val()+"/"+date.child('month').val()+"/"+date.child('year').val();
      return date.child('year').val()+"/"+date.child('month').val()+"/"+date.child('day').val();
    }
    public getFormatedDateForDateObject(date)
    {
      if(date!=null)
      return date.day+" "+monthNames[date.month - 1]+", "+date.year;
    }
    public getDateFromDateObject(date)
    {
      //return date.day+"/"+date.month+"/"+date.year;
      return date.year+"/"+date.month+"/"+date.day;
    }

    public todaysDate()
    {
      var date = new Date();
      return date.getFullYear()+"/"+date.getMonth()+1+"/"+date.getDate();
    }
    public isSameDate(date1, date2)
      {
        var today = new Date("2019-04-27"); 
        var yesterday = new Date("2019-04-27");

        return date1.getTime() == date2.getTime() ? true: false;
        /*   if(yesterday.getTime() == today.getTime()){ 
            console.log("Given dates are same");
        }else{
          console.log("Given dates are different "); 
          } */
      }

      public getFormatedDateFromFullDate(date)
      {
        if(date!=null)
        return date.getDate()+" "+monthNames[date.getMonth()]+", "+date.getFullYear();
      }


checkDates(dateFrom,dateTo,dateCheck)
{
// var dateFrom = "02/05/2013";
// var dateTo = "02/09/2013";
// var dateCheck = "02/03/2013";

var d1 = dateFrom.split("/");
var d2 = dateTo.split("/");
var c = dateCheck.split("/");
//console.log("date ",dateFrom,dateTo,dateCheck);
var from = new Date(Number(d1[0]), parseInt(d1[1]), Number(d1[2]));  // -1 because months are from 0 to 11
var to   = new Date(Number(d2[0]), parseInt(d2[1]), Number(d2[2]));
var check = new Date(Number(c[0]), parseInt(c[1]), Number(c[2]));
var flag = check > from && check < to;
return flag;
//console.log("date "+dateCheck+" is between "+dateFrom+" and "+dateTo+" dates ", flag);
}
checkDatesFromTo(dateFrom,dateTo,dateCheck)
{
// var dateFrom = "02/05/2013";
// var dateTo = "02/09/2013";
// var dateCheck = "02/03/2013";

var d1 = dateFrom.split("/");
var d2 = dateTo.split("/");
var c = dateCheck.split("/");
//console.log("date ",dateFrom,dateTo,dateCheck);
var from = new Date(Number(d1[0]), parseInt(d1[1]), Number(d1[2]));  // -1 because months are from 0 to 11
var to   = new Date(Number(d2[0]), parseInt(d2[1]), Number(d2[2]));
var check = new Date(Number(c[2]), parseInt(c[1]), Number(c[0]));
var flag = check >= from && check <= to;
return flag;
//console.log("date "+dateCheck+" is between "+dateFrom+" and "+dateTo+" dates ", flag);
}

countOccurances(array)
{
  var counts = {};
  array.forEach(function(x) { counts[x] = (counts[x] || 0)+1; });
  return counts;
}
get getCountries()
{
  return country_list;
}

getMonthName(dateInput)
{
  var date =  new Date(dateInput);
  return monthNames[date.getMonth()+1];
}
get fullMonthNames()
{
  return fullMonthNames;
}
get monthNames()
{
  return monthNames;
}
get monthOptions()
{
  return monthOptions;
}
inWords (num) {
  //console.log("num",num);
  var a = ['','one ','two ','three ','four ', 'five ','six ','seven ','eight ','nine ','ten ','eleven ','twelve ','thirteen ','fourteen ','fifteen ','sixteen ','seventeen ','eighteen ','nineteen '];
  var b = ['', '', 'twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety'];
  if ((num = num.toString()).length > 9) return 'overflow';
  var n =[];
  n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return; var str = '';
  str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
  str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
  str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
  str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
  // str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
  str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + '' : '';
  //console.log("str",str);
  return str;
}
getDiff(date1,date2)
  {
    //var diff = Math.abs(date1.getTime() - date2.getTime()) / 3600000;
    var diff = Math.abs(date1.getTime() - date2.getTime());
    return diff;
  }
  msToTime(duration) {
    var milliseconds = parseInt(String((duration % 1000) / 100));
    var seconds = Math.floor((duration / 1000) % 60);
    var minutes = Math.floor((duration / (1000 * 60)) % 60);
    var hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    //return (((hours < 10) ? "0" + hours : hours) + ":" + ((minutes < 10) ? "0" + minutes : minutes) + ":" + ((seconds < 10) ? "0" + seconds : seconds) + "." + milliseconds);
    return (((hours < 10) ? "0" + hours : hours) + ":" + ((minutes < 10) ? "0" + minutes : minutes));
  }
  getDateSearchForm(date:Date)
  {

    return date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
  }
  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
}

checkDatesWithinRange(dateFrom,dateTo,dateCheck)
{
// var dateFrom = "02/05/2013";
// var dateTo = "02/09/2013";
// var dateCheck = "02/03/2013";

var d1 = dateFrom.split("/");
var d2 = dateTo.split("/");
var c = dateCheck.split("/");
//console.log("date ",dateFrom,dateTo,dateCheck);
var from = new Date(Number(d1[2]), parseInt(d1[1]), Number(d1[0]));  // -1 because months are from 0 to 11
var to   = new Date(Number(d2[2]), parseInt(d2[1]), Number(d2[0]));
var check = new Date(Number(c[2]), parseInt(c[1]), Number(c[0]));
var flag = check >= from && check <= to;
return flag;
//console.log("date "+dateCheck+" is between "+dateFrom+" and "+dateTo+" dates ", flag);
}
checkDatesExistsWithinRange(dateFrom,dateTo,dateCheck)
{
// var dateFrom = "02/05/2013";
// var dateTo = "02/09/2013";
// var dateCheck = "02/03/2013";

var d1 = dateFrom.split("-");
var d2 = dateTo.split("-");
var c = dateCheck.split("-");
//console.log("date ",dateFrom,dateTo,dateCheck);
var from = new Date(Number(d1[2]), parseInt(d1[1]), Number(d1[0]));  // -1 because months are from 0 to 11
var to   = new Date(Number(d2[2]), parseInt(d2[1]), Number(d2[0]));
var check = new Date(Number(c[2]), parseInt(c[1]), Number(c[0]));
var flag = check >= from && check <= to;
return flag;
//console.log("date "+dateCheck+" is between "+dateFrom+" and "+dateTo+" dates ", flag);
}
getTimeIn24HoursFormat(timeInput)
  {
    var t1 = timeInput.split(" ");
    var t2 = t1[0].split(":");
    var time = t1[1] == "PM"?Number(t2[0])+12:t1[1] == "AM" && t2[0] == "12"?0:t2[0];
    //console.log("t",time);
    var object = {hour: Number(time), minute: Number(t2[1]), second: 0};
    //console.log("object",object);
    return object;
  }
  getFormattedDate(timeInput)
  {
    var time  = (timeInput.hour==0?12:timeInput.hour <= 12?timeInput.hour:timeInput.hour - 12)+":"+timeInput.minute+" "+(timeInput.hour>=12?"PM":"AM");
    //var time  = (clockIn.hour==0?12:clockIn.hour <= 12?clockIn.hour:clockIn.hour - 12)+":"+clockIn.minute+" "+(clockIn.hour>=12?"PM":"AM");
    //var clockOutTime  = (clockOut.hour==0?12:clockOut.hour <= 12?clockOut.hour:clockOut.hour - 12)+":"+clockOut.minute+" "+(clockOut.hour>=12?"PM":"AM");
    return time;
  }
  sortList(data)
{
  data.sort(function(a,b){
    var c = new Date(a.Date);
    var d = new Date(b.Date);
    return d.getTime() - c.getTime();  
    });
}
getTimeOrDayDiff(date1,date2)
{
  var diffTime = Math.abs(date1.getTime() - date2.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
  //console.log("diffDays",diffDays);
  if(diffDays > 1 )
  return this.msToTimeFromDate(diffTime);
  else
  return diffDays;
}
msToTimeFromDate(duration) {
  var milliseconds = parseInt(String((duration % 1000) / 100));
  var seconds = Math.floor((duration / 1000) % 60);
  var minutes = Math.floor((duration / (1000 * 60)) % 60);
  var hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
  return (((hours < 10) ? "0" + hours : hours) + ":" + ((minutes < 10) ? "0" + minutes : minutes) + ":" + ((seconds < 10) ? "0" + seconds : seconds) + "." + milliseconds);
}
geTimeDiff(duration)
{
  var milliseconds = parseInt(String((duration % 1000) / 100));
  var seconds = Math.floor((duration / 1000) % 60);
  var minutes = Math.floor((duration / (1000 * 60)) % 60);
  var hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
  return  hours;
}
diff_hours(dt2, dt1) 
 {

  var diff =(dt2.getTime() - dt1.getTime()) / 1000;
  diff /= (60 * 60);
  return Math.abs(Math.round(diff));
  
 }
 diff(date2,date1)
 {
  // Convert both dates to milliseconds
  var date1_ms = date1.getTime();
  var date2_ms = date2.getTime();

  // Calculate the difference in milliseconds
  var difference_ms = date2_ms - date1_ms;
  //take out milliseconds
  difference_ms = difference_ms/1000;
  var seconds = Math.floor(difference_ms % 60);
  difference_ms = difference_ms/60; 
  var minutes = Math.floor(difference_ms % 60);
  difference_ms = difference_ms/60; 
  var hours = Math.floor(difference_ms % 24);  
  var days = Math.floor(difference_ms/24);
  return days > 0?days+" Days ago":Math.abs(hours)+" Hrs "+Math.abs(minutes)+" Mins ago";
 }
}


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/shared/util.service.ts